module.exports = __webpack_public_path__ + "static/media/desbravador_d.c6aa5cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/desbravador_d.png
// module id = 1182
// module chunks = 0